import { useToast } from '@/hooks/useToast';
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from './Toast';

/**
 * Mounted once, in App.tsx, alongside the app shell — every screen calls
 * `toast(...)` from `hooks/useToast.ts` and this is the only thing that
 * actually renders the queue it produces. See Toast.tsx's own header
 * comment for why this exists (backlog #20) and useToast.ts's for why the
 * store is a module singleton rather than context.
 */
export function Toaster() {
  const { toasts, dismiss } = useToast();

  return (
    <ToastProvider>
      {toasts.map(({ id, title, description, action, variant, open }) => (
        <Toast key={id} variant={variant} open={open} onOpenChange={(next) => { if (!next) dismiss(id); }}>
          <div className="flex-1">
            {title && <ToastTitle>{title}</ToastTitle>}
            {description && <ToastDescription>{description}</ToastDescription>}
          </div>
          {action}
          <ToastClose />
        </Toast>
      ))}
      {/* Offset up past the ClintoBytes Copilot launcher (56px + 8px) so toasts stack above the button, not under it. */}
      <ToastViewport className="bottom-[64px]" />
    </ToastProvider>
  );
}
